<template>
  <b-card>
    <!-- <b-card-body>
      <b-button variant="success" @click="importData()"
        >به روز رسانی داده ها</b-button
      >
    </b-card-body> -->
    <b-tabs
      :vertical="window.width >= 407 ? false : true"
      nav-wrapper-class="w-100"
    >
      <b-tab title="تسویه ها" active>
        <ayandereport></ayandereport>
      </b-tab>
      <b-tab title="برداشت های به تاریخ">
        <ayandecredit></ayandecredit>
      </b-tab>
      <!-- <b-tab title="واریزی ها">
        <list-table
          :url="url"
          title="گزارش واریزی به بانک آینده"
          :fields="fields"
          :params="params"
          :excelroute="''"
        ></list-table>
      </b-tab>
      <b-tab title="برداشت ها">
        <list-table
          :url="'inandout?typeofpayment=0'"
          title="گزارش برداشت ها از بانک آینده"
          :fields="fields1"
          :params="params"
          :excelroute="''"
        ></list-table>
      </b-tab> -->
    </b-tabs>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";
import ayandereport from "../Report/ayandereport.vue";
import AyandeCreadit from "../Report/AyandeCreadit.vue";
export default {
  name: "AccReport",
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      merchants: [],
      url: "inandout?typeofpayment=2",
      params: [
        {
          label: "از تاریخ:",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker",
        },
        {
          label: "نام مشتری:",
          field: "acceptor_code",
          type: "vselect",
          options: this.merchants,
        },
        {
          label: "بانک:",
          field: "bank_id",
          type: "mddropdown",
          group: 13,
        },
        {
          label: "کد رهگیری:",
          field: "trackingNumber",
          type: "text",
          group: 13,
        },
        {
          label: "مبلغ (ریال):",
          field: "amount",
          type: "number",
        },
      ],
      fields: [
        {
          key: "name",
          label: "مشتری",
        },
        {
          key: "website_name",
          label: "وبسایت مشتری",
          formatter(value, key, item) {
            return item.website_name + " (" + item.website_en_name + ")";
          },
        },
        {
          key: "date",
          label: "تاریخ",
          formatter(value, key, item) {
            return (
              value.substring(0, 4) +
              "/" +
              value.substring(4, 6) +
              "/" +
              value.substring(6, 8)
            );
          },
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "trackingNumber",
          label: "کد رهگیری",
        },
      ],
      fields1: [
        {
          key: "name",
          label: "مشتری",
        },
        {
          key: "iban",
          label: "شماره شبا",
        },
        {
          key: "website_name",
          label: "وبسایت مشتری",
          formatter(value, key, item) {
            return item.website_name + " (" + item.website_en_name + ")";
          },
        },
        {
          key: "date",
          label: "تاریخ",
          formatter(value, key, item) {
            return (
              value.substring(0, 4) +
              "/" +
              value.substring(4, 6) +
              "/" +
              value.substring(6, 8)
            );
          },
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "typeofpayment",
          label: "نوع برداشت",
          formatter(value, key, item) {
            return value == 0 ? "وجه اصلی" : value == 4 ? "کارمزد نظام بانکی" : "کارمزد";
          },
        },
        {
          key: "title",
          label: "نام بانک",
          formatter(value, key, item) {
            var newVal = item.iban;
            if (newVal) {
              newVal = newVal.substring(4, 8);
              if (newVal.startsWith("055")) {
                return "بانک اقتصاد نوین";
              } else if (newVal.startsWith("054")) {
                return "بانک پارسیان";
              } else if (newVal.startsWith("057")) {
                return "بانک پاسارگاد";
              } else if (newVal.startsWith("021")) {
                return "پست بانک";
              } else if (newVal.startsWith("018")) {
                return 521;
              } else if (newVal.startsWith("051")) {
                return "موسسه اعتباری توسعه";
              } else if (newVal.startsWith("019")) {
                return "بانک صادرات";
              } else if (newVal.startsWith("013")) {
                return "بانک رفاه کارگران";
              } else if (newVal.startsWith("056")) {
                return "بانک سامان";
              } else if (newVal.startsWith("015")) {
                return "بانک سپه";
              } else if (newVal.startsWith("058")) {
                return "بانک سرمایه";
              } else if (newVal.startsWith("011")) {
                return "بانک صنعت و معدن";
              } else if (newVal.startsWith("053")) {
                return "بانک کارآفرین";
              } else if (newVal.startsWith("016")) {
                return "باک کشاورزی";
              } else if (newVal.startsWith("010")) {
                return "بانک مرکزی";
              } else if (newVal.startsWith("014")) {
                return "بانک مسکن";
              } else if (newVal.startsWith("012")) {
                return "بانک ملت";
              } else if (newVal.startsWith("017")) {
                return "بانک ملی";
              } else if (newVal.startsWith("070")) {
                return "بانک رسالت";
              } else if (newVal.startsWith("063")) {
                return "بانک انصار";
              } else if (newVal.startsWith("061")) {
                return "بانک شهر";
              } else if (newVal.startsWith("052")) {
                return "بانک قوامین";
              } else if (newVal.startsWith("069")) {
                return "بانک ایران زمین";
              } else if (newVal.startsWith("062")) {
                return "بانک آینده";
              } else if (newVal.startsWith("022")) {
                return "بانک توسعه تعاون";
              } else if (newVal.startsWith("065")) {
                return "بانک حکمت ایرانیان";
              } else if (newVal.startsWith("066")) {
                return "بانک دی";
              } else if (newVal.startsWith("059")) {
                return "بانک سینا";
              } else if (newVal.startsWith("060")) {
                return "بانک قرض الحسنه مهر ایران";
              } else if (newVal.startsWith("064")) {
                return "بانک گردشگری";
              } else if (newVal.startsWith("079")) {
                return "بانک مهر اقتصاد";
              } else if (newVal.startsWith("073")) {
                return "موسسه اعتباری کوثر";
              } else if (newVal.startsWith("020")) {
                return "بانک توصعه صادرات ایران";
              } else if (newVal.startsWith("078")) {
                return "بانک خاورمیانه";
              } else if (newVal.startsWith("095")) {
                return "بانک مشترک ایران - ونزوئلا";
              } else if (newVal.startsWith("075")) {
                return "موسسه اعتباری ملل";
              } else if (newVal.startsWith("080")) {
                return "موسسه اعتباری نور";
              } else {
                return null;
              }
            } else {
              return null;
            }
          },
        },
        {
          key: "trackingNumber",
          label: "کد رهگیری",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گزارش حسابداری" }]);
    httpHelper.getData("inandout/merchants").then((res) => {
      this.params[2].options = res.map((element) => {
        return {
          value: element.acceptor_code,
          text:
            element.name +
            "-" +
            element.website_name +
            "(" +
            element.website +
            ")",
        };
      });
    });
  },
  components: {
    "list-table": TableShowData,
    ayandereport,
    'ayandecredit':AyandeCreadit
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    ibanNumber: (newVal) => {},
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    importData() {
      httpHelper.getData("inandout/import").then((res) => {});
    },
  },
};
</script>